import PointPreloader from '@Components/Preloaders/PointPreloader'
import { MemberSummary } from '@Entities/member/member-summary'
import PaginationComponent from '@Components/Tables/Pagination'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PaginationBody } from '@Entities/pagination'
import { observer } from 'mobx-react'
import RightsholderAccountCard from '@Components/Cards/AccountCard/RightsholderAccountCard'
import SearchInput from '@Components/Search/SearchInput'

const MemberInternalScene = () => {
    const { rightsholderSearchStore, popupStore } = useContext(StoresContext)
    const [preloaderIsOpen, setPreloaderIsOpen] = useState<boolean>(false)
    const [searchValue, setSearchValue] = useState<string>(rightsholderSearchStore.currentSearchValue)
    const didMount = useRef(false)
    const limitItems = 9

    useEffect(() => {
        analyticsSendPage('home_internal')
        if (!didMount.current && rightsholderSearchStore.rightsholders) {
            didMount.current = true
            return
        }

        didMount.current = true
        eventGetRightsHolders().then()
    }, [searchValue])

    const eventGetRightsHolders = async (callBackPagination?: PaginationBody) => {
        let pagination: PaginationBody = {
            page: 1,
            limit: limitItems,
        }

        if (callBackPagination) {
            pagination = {
                ...pagination,
                ...callBackPagination,
            }
        }

        try {
            setPreloaderIsOpen(true)
            await rightsholderSearchStore.loadRightsholders(pagination, searchValue)
        } catch (error) {
            popupStore.setAlertFromError(error)
        } finally {
            setPreloaderIsOpen(false)
        }
    }

    return (
        <div className="home-internal-accounts-tab">
            <div className="search-all-block">
                <p>
                    {rightsholderSearchStore.rightsholders && rightsholderSearchStore.rightsholders.totalElements}{' '}
                    Member accounts
                </p>
                <SearchInput
                    id="publisher-search"
                    placeholder="Search Members"
                    buttonClick={setSearchValue}
                    onClearInput={() => setSearchValue('')}
                    value={rightsholderSearchStore.currentSearchValue}
                />
            </div>
            <div className="accounts-block">
                {preloaderIsOpen ? (
                    <PointPreloader />
                ) : (
                    rightsholderSearchStore.rightsholders?.content.map((item: MemberSummary, index: number) => (
                        <RightsholderAccountCard key={item.ipId ? item.ipId : index} rightsholderData={item} />
                    ))
                )}
                {!preloaderIsOpen &&
                    rightsholderSearchStore.rightsholders &&
                    !rightsholderSearchStore.rightsholders.totalElements && (
                        <p className="small no-results">No members</p>
                    )}
            </div>
            <PaginationComponent
                limit={limitItems}
                paginationPages={rightsholderSearchStore.paginationInfo}
                onChange={eventGetRightsHolders}
            />
        </div>
    )
}
export default observer(MemberInternalScene)
